var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container light-gray text-center"},[_c('h3',[_c('small',{staticClass:"text-muted center"},[_vm._v("This page is restricted! "+_vm._s(_vm.isValidUser))]),_c('br'),_c('small',{staticClass:"text-muted center"},[_vm._v("Please sign in.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a8c78d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-restricted.vue
// module id = null
// module chunks = 